import { DeviceType } from '@ixicare/resources';
import { IXI_LITE_TYPES, WRISTWATCH_TYPES } from './constants';

/**
 * The device types one site-level configuration form writes to.
 *
 * Types sharing a firmware share a configuration form, and a legacy name and its ixi replacement
 * are one product. The configuration service knows nothing of these groupings — it stores and
 * collates strictly per type — so every member has to be written, or devices of the types left
 * out silently keep the old values.
 *
 * A type absent here has no configuration form at all (gateways, Eview, Twig), which is why the
 * site configuration entry point is hidden on those tabs.
 */
const SITE_CONFIG_GROUPS: Partial<Record<DeviceType, DeviceType[]>> = {
  [DeviceType.WATCHERR]: WRISTWATCH_TYPES,
  [DeviceType.IXI_PRO]: WRISTWATCH_TYPES,
  [DeviceType.WRISTBAND_DISTRESS_BUTTON]: IXI_LITE_TYPES,
  [DeviceType.IXI_LITE]: IXI_LITE_TYPES,
  [DeviceType.IXI_TOUCH]: [DeviceType.IXI_TOUCH],
  [DeviceType.IXI_BLACK]: [DeviceType.IXI_BLACK],
  [DeviceType.WALL_MOUNTED_DISTRESS_BUTTON]: [DeviceType.WALL_MOUNTED_DISTRESS_BUTTON],
};

/** Whether a site-level configuration form exists for this device type. */
export const hasSiteConfig = (deviceType?: DeviceType | null): boolean =>
  !!deviceType && deviceType in SITE_CONFIG_GROUPS;

/**
 * Every device type one site-level form writes to. Falls back to the type itself so a caller
 * never ends up writing nothing.
 */
export const siteConfigGroup = (deviceType: DeviceType): DeviceType[] => SITE_CONFIG_GROUPS[deviceType] ?? [deviceType];
